import FilterOption from "@/features/sub-families/components/filter-option.tsx";
import NoFilterOptions from "@/features/sub-families/components/filters/internal/no-filter-options.tsx";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { type ChangeValue, FilterType } from "@/features/sub-families/types";
import { createFilterOption, lightAccessoriesToChoices } from "@/features/sub-families/utils/filters.ts";
import { getAccessories } from "@/services/product/utils/accessories.ts";
import { type Nullish, SmartNumberDescriptor } from "@/types";

type Props = { selectedLabel: Nullish<string>; onChange: (value: ChangeValue) => void };
export default function AccessoriesFilter({ selectedLabel, onChange }: Props) {
    const currentProduct = useCurrentProduct();

    if (!currentProduct) return null;

    const choices = lightAccessoriesToChoices(getAccessories(currentProduct));
    if (choices.length === 0) return <NoFilterOptions />;

    const config = createFilterOption({
        label: "accessories",
        filterType: FilterType.RadioImages,
        descriptor: SmartNumberDescriptor.Accessory,
        choices,
    });

    return (
        <div className="accessories-filter">
            <FilterOption
                idx={0}
                productProperty="light_acc"
                config={config}
                selectedLabel={selectedLabel}
                onChange={onChange}
                allowToggle
            />
        </div>
    );
}
